import * as React from 'react';

import { VIDEO_TUTORIALS } from '../constants';
import { IVideoDetails } from '../interfaces';
import { ModalVideoPlayer } from './index';

interface IProps {
  id?: string;
  videoInfo: IVideoDetails;
}

function VideoTutorial(props: IProps) {
  const [shouldShowVideo, setShouldShowVideo] = React.useState(false);

  const handleTutorialOverlayClick = () => {
    setShouldShowVideo(true);
  };

  let {
    id,
    videoInfo: {
      // quote,
      // company,
      companyLogoUrl,
      // name,
      title,
      description,
      videoUrl,
      isSelfHosted,
      relatedVideos,
    },
  } = props;

  const bgStyle = {
    backgroundImage: `url(${companyLogoUrl})`,
  };

  return (
    <>
      <div
        data-qa={id}
        className="home-page__tutorial-video-card"
        onClick={handleTutorialOverlayClick}
      >
        <div className="home-page__tutorial-video-card-top-image" style={bgStyle} />
        <div className="home-page__tutorial-video-card-bottom-container">
          <h4 className={`home-page__tutorial-video-card-bottom-category`}>Video Tutorial</h4>
          <h3 className={`home-page__tutorial-video-card-bottom-title`}>{title}</h3>
          <p className="home-page__tutorial-video-card-bottom-description">{description}</p>
        </div>
      </div>

      {shouldShowVideo && (
        <ModalVideoPlayer
          videoUrl={videoUrl}
          isSelfHosted={isSelfHosted}
          description={description}
          title={title}
          relatedVideos={relatedVideos ? relatedVideos : undefined}
          potentialVideos={VIDEO_TUTORIALS}
          onClose={() => setShouldShowVideo(false)}
        />
      )}
    </>
  );
}

export { VideoTutorial };
